<h1 mat-dialog-title>
    Choose a contractor that you would like to review.
    <div style="float: right !important;">
      <a
        href="javascript:void(0)"
        (click)="onClickCancel()"
        style="color: #8f8f8f">
        <mat-icon
          style="size: 18px;"
          matTooltip="Close form"
          matTooltipPosition="below">
          close
        </mat-icon>
      </a>
    </div>
  </h1>
<div mat-dialog-content>
  <form
      [formGroup]="formContractorReviewList"
      autocomplete="off"
      style="padding:10px 0 20px 0; width: 100%;"
    >
    <div class="mat-elevation-z7 scroll-table" width="100%"
    >
    <table mat-table
      [dataSource]="dataSourceTable" style="width: 100%;"
      >
        <ng-container matColumnDef="bizId">
          <th mat-header-cell *matHeaderCellDef> Business Name </th>
          <td mat-cell width="40%"  style="height: 90px;" *matCellDef="let item">
            <div ngStyle.lt-md="{ 'margin-left': '9px' }">
              <div
                matTooltip="{{item.contractorBusinessName}}"
                class="business-name"
              >
                 {{ item.contractorBusinessName }}
              </div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef>Action</th>
          <td mat-cell width="10%" *matCellDef="let item">
            <div>
              <button
                mat-stroked-button
                color="accent"
                (click)="onSelectContractor(item)"
                *ngIf="item.contractorReview === null || item.contractorReview === undefined || item.contractorReview.length <= 0"
              >
                ADD
              </button>
              <button
                mat-stroked-button
                color="accent"
                (click)="onSelectContractor(item)"
                *ngIf="item.contractorReview !== null && item.contractorReview !== undefined && item.contractorReview.length > 0 && item.contractorResponse === null"
              >
                EDIT
              </button>
              <button
              mat-stroked-button
              color="accent"
              (click)="onSelectContractor(item)"
              *ngIf="item.contractorReview !== null && item.contractorReview !== undefined && item.contractorReview.length > 0 && item.contractorResponse !== null"
            >
              VIEW
            </button>
           
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </form>
  </div>
  